import { useNavigate } from 'react-router-dom'
import { User } from '../types'
import './RoleSelector.css' // Reusing styles

interface PropertyRoleSelectorProps {
  onRoleSelect: (role: 'property_referent' | 'requester') => void
  currentUser?: User
}

function PropertyRoleSelector({ onRoleSelect, currentUser }: PropertyRoleSelectorProps) {
  const navigate = useNavigate()

  // Функция для получения чешского названия роли
  const getRoleLabel = (role: string) => {
    switch (role) {
      case 'property_referent':
        return 'Referent správy majetku'
      case 'requester':
        return 'Žadatel'
      default:
        return role
    }
  }

  // Проверяем, имеет ли пользователь доступ к ролям
  // Референт справі маетку - только property_referent и IT админ
  const canBePropertyReferent = (currentUser?.role === 'admin' && currentUser?.admin_type === 'spravce_it') || currentUser?.role === 'property_referent'
  // Жадатель - может зайти кто угодно (все аутентифицированные пользователи)
  const canBeRequester = true // Все могут быть жадателями
  const isITAdmin = currentUser?.role === 'admin' && currentUser?.admin_type === 'spravce_it'

  const handleRoleClick = (role: 'property_referent' | 'requester') => {
    // IT администратор может выбрать любую роль
    if (isITAdmin) {
      onRoleSelect(role)
      return
    }

    // Проверяем доступ к конкретной роли
    let hasAccess = false
    switch (role) {
      case 'property_referent':
        hasAccess = canBePropertyReferent
        break
      case 'requester':
        hasAccess = canBeRequester
        break
    }

    if (hasAccess) {
      onRoleSelect(role)
    } else {
      alert('Nemáte přístup k této roli')
    }
  }

  return (
    <div className="role-selector">
      <div className="role-selector-container">
        <button className="back-to-roles-button" onClick={() => navigate('/intranet')}>
          ← Zpět
        </button>
        <h1>Správy majetku</h1>
        <p className="subtitle">Vyberte svou roli pro přístup k systému</p>
        <div className="role-buttons">
          <button
            className={`role-button ${!canBePropertyReferent && !isITAdmin ? 'disabled' : ''}`}
            onClick={() => handleRoleClick('property_referent')}
            disabled={!canBePropertyReferent && !isITAdmin}
          >
            <h2>{getRoleLabel('property_referent')}</h2>
            {!canBePropertyReferent && !isITAdmin && (
              <span className="disabled-badge">Nedostupné</span>
            )}
          </button>

          <button
            className={`role-button ${!canBeRequester && !isITAdmin ? 'disabled' : ''}`}
            onClick={() => handleRoleClick('requester')}
            disabled={!canBeRequester && !isITAdmin}
          >
            <h2>{getRoleLabel('requester')}</h2>
            {!canBeRequester && !isITAdmin && (
              <span className="disabled-badge">Nedostupné</span>
            )}
          </button>
        </div>
        {currentUser && (
          <div style={{ 
            marginTop: '2rem', 
            padding: '1rem 1.5rem', 
            background: 'linear-gradient(135deg, #0d9488 0%, #14b8a6 100%)', 
            borderRadius: '12px',
            color: 'white',
            textAlign: 'center',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
          }}>
            <p style={{ margin: 0, fontSize: '1rem', fontWeight: '500' }}>
              <strong>{currentUser.name}</strong>
            </p>
          </div>
        )}
      </div>
    </div>
  )
}

export default PropertyRoleSelector

